import React, {createContext} from 'react'


export const EventContext = createContext({})
